import { render, staticRenderFns } from "./msgList.vue?vue&type=template&id=9f206e12"
import script from "./msgList.vue?vue&type=script&lang=js"
export * from "./msgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f206e12')) {
      api.createRecord('9f206e12', component.options)
    } else {
      api.reload('9f206e12', component.options)
    }
    module.hot.accept("./msgList.vue?vue&type=template&id=9f206e12", function () {
      api.rerender('9f206e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/message/msgList.vue"
export default component.exports